/** `null` (alone or in a list) is a key sent without a value, as the browser query parser reports it. */
export type IOfferListQueryValue = string | number | boolean | null | undefined | (string | number | null)[];

export type IOfferListUrlInput = Record<string, IOfferListQueryValue>;

export const toValueList = (value: IOfferListQueryValue): string[] => {
    if (value == null || value === "") {
        return [];
    }

    const list = Array.isArray(value) ? value : [value];

    return list
        .filter((item) => item != null)
        .map((item) => String(item))
        .filter((item) => item !== "");
};

export const toOptionalNumber = (value: IOfferListQueryValue): number | undefined => {
    const [first] = toValueList(value);

    if (first == null) {
        return undefined;
    }

    const parsed = parseInt(first, 10);

    return Number.isFinite(parsed) ? parsed : undefined;
};

/** One property type, or `undefined` for none or several (`[FLAT, HOUSE]` is the default `mieszkania-i-domy` listing, not flats). */
export const toOfferListType = (value: IOfferListQueryValue): number | undefined => {
    const values = toValueList(value);

    return values.length === 1 ? toOptionalNumber(values[0]) : undefined;
};

export const toRegionSlug = (value: IOfferListQueryValue): string | undefined => toValueList(value)[0];

export const isTruthyFlag = (value: IOfferListQueryValue): boolean => value === true || value === "true";

export const shouldOmitQueryValue = (value: IOfferListQueryValue): boolean => {
    if (value == null || value === "" || value === false || value === "false") {
        return true;
    }

    if (Array.isArray(value)) {
        return value.filter((item) => item != null && item !== "").length === 0;
    }

    return false;
};

export const hasNumericValue = (value: IOfferListQueryValue): boolean =>
    toValueList(value).some((item) => {
        const parsed = parseInt(item, 10);

        return Number.isFinite(parsed);
    });
/** `null` (alone or in a list) is a key sent without a value, as the browser query parser reports it. */
export type IOfferListQueryValue = string | number | boolean | null | undefined | (string | number | null)[];

export type IOfferListUrlInput = Record<string, IOfferListQueryValue>;

export const toValueList = (value: IOfferListQueryValue): string[] => {
    if (value == null || value === "") {
        return [];
    }

    const list = Array.isArray(value) ? value : [value];

    return list
        .filter((item) => item != null)
        .map((item) => String(item))
        .filter((item) => item !== "");
};

export const toOptionalNumber = (value: IOfferListQueryValue): number | undefined => {
    const [first] = toValueList(value);

    if (first == null) {
        return undefined;
    }

    const parsed = parseInt(first, 10);

    return Number.isFinite(parsed) ? parsed : undefined;
};

/** One property type, or `undefined` for none or several (`[FLAT, HOUSE]` is the default `mieszkania-i-domy` listing, not flats). */
export const toOfferListType = (value: IOfferListQueryValue): number | undefined => {
    const values = toValueList(value);

    return values.length === 1 ? toOptionalNumber(values[0]) : undefined;
};

export const toRegionSlug = (value: IOfferListQueryValue): string | undefined => toValueList(value)[0];

export const isTruthyFlag = (value: IOfferListQueryValue): boolean => value === true || value === "true";

export const shouldOmitQueryValue = (value: IOfferListQueryValue): boolean => {
    if (value == null || value === "" || value === false || value === "false") {
        return true;
    }

    if (Array.isArray(value)) {
        return value.filter((item) => item != null && item !== "").length === 0;
    }

    return false;
};

export const hasNumericValue = (value: IOfferListQueryValue): boolean =>
    toValueList(value).some((item) => {
        const parsed = parseInt(item, 10);

        return Number.isFinite(parsed);
    });
